import { v4 as uuidv4 } from 'uuid';
import type { RootState } from "app/store";
import getBrandName from "app/shared/utils/BrandHelper";
import FeatureFlags from "app/shared/constants/FeatureFlags";
import { encryptURI } from "app/shared/utils/ValueEncryption";
import { CLIENT_META_HEADER, getClientMeta } from "./clientMeta";

// eslint-disable-next-line import/no-cycle
const {appSource} = getBrandName();

type HeaderOptions = {
    isToastRequest?: boolean;
};

const getHeader = (
    getState: () => unknown,
    headers: Headers,
    { isToastRequest = false }: HeaderOptions = {},
) => {
    const state = getState() as RootState;
    const { user, isGuest, token } = state.auth;
    const { enterpriseUnitId } = state.orders;

    if (isGuest) {
        headers.set('guest', encryptURI("true"));

        if (token) {
            headers.set('guest-token', encryptURI(`Bearer ${token}`));
        }
    }

    // user is used for tracking
    if (user) {
        headers.set('aud', encryptURI(user));
    }

    if (enterpriseUnitId) {
        headers.set('enterpriseunitid', encryptURI(enterpriseUnitId));
    }

    const appSourceVal = encryptURI(appSource);
    const appPlatformVal = encryptURI(navigator.userAgent);
    headers.set('sourceAppBrand', appSourceVal);
    headers.set('sourceAppPlatform', appPlatformVal);

    const isToastEnabled = state.auth.configs?.env?.[FeatureFlags.TOAST] === 'true';
    if (isToastEnabled && isToastRequest) {
        headers.set(CLIENT_META_HEADER, getClientMeta());
    }

    let traceId = localStorage.getItem('trace_id');
    if (!traceId) {
        traceId = uuidv4();
        localStorage.setItem('trace_id', traceId);
    }
    headers.set('trace_id', traceId);
    return headers;
};

export default getHeader;
